/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/prop-types */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-empty-function */

import React, { SetStateAction, useCallback, useEffect, useState } from 'react'
import { Collapse } from '@material-ui/core';
import { Adjust, Call, CallEnd, CallMissed, Cancel, FiberManualRecord, HourglassEmpty, HourglassFull, KeyboardArrowDown, KeyboardArrowUp, People, PersonOutline, PersonRounded, Phone, PhoneInTalk, RadioButtonChecked, SettingsPhone, Voicemail } from '@material-ui/icons';
import { WidgetMetric } from './QueueWidgetContainer';
import RcButton from './UiUtilities/Button';

interface AgentInfo {
  name: string,
  id: string,
  displayStatus: string;
  availableAccepting: boolean,
  busyAccepting: boolean,
  notAccepting: boolean,
  department: string;
  status: string;
  lastMessage?: string;
  lastPresenceStatus?: string;
  portrait: string;
  onQueueCall: any;
}

const LiveSummary = React.memo(({ agent }: { agent: AgentInfo }) => {
  const [elapsedTime, setElapsedTime] = useState("00:00:00");

  useEffect(() => {
    const updateElapsedTime = () => {
      const start = new Date(agent.onQueueCall.time).getTime();
      const now = Date.now();
      const seconds = Math.floor((now - start) / 1000);
      const hh = String(Math.floor(seconds / 3600)).padStart(2, "0");
      const mm = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
      const ss = String(seconds % 60).padStart(2, "0");
      setElapsedTime(`${hh}:${mm}:${ss}`);
    };

    if (!agent?.onQueueCall || (agent.onQueueCall.state !== "ON QUEUE CALL" && agent.onQueueCall.state !== "ON CALL" && agent.onQueueCall.state !== "TALKING")) {
      setElapsedTime(""); 
      return undefined;
    }
    
    updateElapsedTime(); 
    const interval = setInterval(updateElapsedTime, 3000);

    return () => clearInterval(interval);

  }, [agent?.onQueueCall?.time, agent?.onQueueCall?.state]);
  if(agent.id === "4524197020"){
    console.log("Live Summary: ", agent);
  }
  

  if (!agent) return null;

  if (!agent.onQueueCall || agent.onQueueCall.state === "IDLE") {
    return <span className='notranslate'>{agent.displayStatus.substring(4)}</span>;
  }
  if (agent.onQueueCall.state === "RINGING") {
    return <>Ringing</>;
  }
  if (agent.onQueueCall.state === "ON CALL") {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
      <Phone fontSize="small" style={{ fontSize: "1em" }} />
      &nbsp;On Call - {elapsedTime}
    </div>
    )
  }
  if (agent.onQueueCall.state === "ON QUEUE CALL") {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <People fontSize="small" style={{ fontSize: "1em" }} />
        &nbsp;On Queue Call - {elapsedTime}
      </div>
    );
  }

  return <>{agent.onQueueCall.state}</>;
});



const WidgetCompact = React.memo(({
  queueName,
  waiting,
  inProgress,
  answered,
  abandoned,
  voicemail,
  missed,
  sidebar,
  mode,
  legacy,
  toggled,
  handleQueueToggle,
  agents,
  available,
  busy,
  unavailable,
  extension,
  queueId,
  excluded,
  queueCompactView,
  userSortOrder,
  userSortDirection,
  userSortField,
  adminClick,
  queueDisplay,
  queueSortField,
  queueSortOrder,
  showPortraits,
  compactWidgetMetrics,
  showAvailable,
  showBusy,
  showDnd,
  showInvisible,
  _setFullscreen
}: {
  excluded: boolean,
  sidebar: boolean,
  extension: number,
  queueName: string;
  waiting: {
    callId: string;
    timestamp: Date;
    phoneNumber: string;
  }[];
  inProgress: number;
  answered: WidgetMetric;
  abandoned: WidgetMetric;
  voicemail: WidgetMetric;
  missed: WidgetMetric;
  mode: string;
  legacy: boolean;
  toggled: boolean;
  handleQueueToggle: (queue: string) => void,
  agents: {
    name: string,
    id: string,
    displayStatus: string;
    availableAccepting: boolean,
    busyAccepting: boolean,
    notAccepting: boolean,
    department: string;
    status: string;
    lastMessage?: string;
    lastPresenceStatus?: string;
    portrait: string;
    onQueueCall: any;
  }[],
  available: number,
  busy: number,
  unavailable: number,
  queueId: string,
  queueCompactView: boolean;
  userSortOrder: string | undefined;
  userSortDirection: any;
  userSortField: any;
  adminClick: (string: string) => void;
  queueDisplay: string | undefined;
  queueSortOrder: string | undefined;
  queueSortField: string | undefined;
  showPortraits: boolean | undefined;
  compactWidgetMetrics: Array<{key: string, label: string, visible: boolean}> | undefined;
  showAvailable: boolean;
  showBusy: boolean;
  showDnd: boolean;
  showInvisible: boolean;
  _setFullscreen: React.Dispatch<SetStateAction<string | undefined>>
}) => {
  

  const [expanded, setExpanded] = useState(true)
  const [queueAgents, setQueueAgents] = useState(agents)
  const totalCalls = (abandoned.weight || 0) + (answered.weight || 0) + (voicemail.weight || 0) + (missed.weight || 0)
  const abandonedPercent = Number.isNaN(Math.floor(abandoned.weight / totalCalls ) * 100) ? 0 : Math.floor(abandoned.weight / totalCalls ) * 100;

  const activeCall = waiting.length > 0;
  const [titleDisplay, setTitleDisplay] = useState(queueDisplay)
  const [_compactWidgetMetrics, _setCompactWidgetMetrics] = useState(compactWidgetMetrics)
  const [longestWait, setLongestWait] = useState("--:--")

  useEffect(() => {
    try {
      const compactQueueState = localStorage.getItem("compactQueueExpandedState");
      if (compactQueueState) {
        const parsedState = JSON.parse(compactQueueState);
        if (parsedState[queueId] !== undefined) {
          setExpanded(parsedState[queueId]);
        }
      }
    } catch (error) {
      console.error("Error parsing compactQueueExpandedState from localStorage:", error);
    }
  }, [queueId]);

  useEffect(() => {
    try {
      const compactQueueState = localStorage.getItem("compactQueueExpandedState") || "{}";
      const parsedState = compactQueueState ? JSON.parse(compactQueueState) : {};
      const compactExpandedState = {
        ...parsedState,
        [queueId]: expanded
      };

      localStorage.setItem("compactQueueExpandedState", JSON.stringify(compactExpandedState));
    } catch (error) {
      console.error("Error saving compactQueueExpandedState to localStorage:", error);
    }
  }, [expanded, queueId]);

   useEffect(() => {
      if (waiting.length === 0) {
        // Clear the longest wait and ensure no interval runs
        setLongestWait("- : - : -");
        return;
      }
  
      const calculateLongestWait = () => {
        const now = Date.now();
        const longestWaitTime = Math.max(
          ...waiting.map((call) => now - new Date(call.timestamp).getTime())
        );
  
        const seconds = Math.floor((longestWaitTime / 1000) % 60);
        const minutes = Math.floor((longestWaitTime / (1000 * 60)) % 60);
        const hours = Math.floor(longestWaitTime / (1000 * 60 * 60));
  
        setLongestWait(
          `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
        );
      };
  
      // Run immediately and set up interval
      calculateLongestWait();
      const interval = setInterval(calculateLongestWait, 1000);
  
      // Cleanup interval on unmount or when waiting becomes empty
      // eslint-disable-next-line consistent-return
      return () => clearInterval(interval);
    }, [waiting]);


  useEffect(() => {
    _setCompactWidgetMetrics(compactWidgetMetrics)
  }, [compactWidgetMetrics])

  useEffect(() => {
    setTitleDisplay(queueDisplay)
  }, [queueDisplay])

  function calculatePresence(user: any) {
    if (user.lastDndStatus === "DoNotAcceptAnyCalls") {
      return "Do Not Disturb";
    }

    if (user.lastPresenceStatus === "Offline") {
      return "Invisible";
    }
    return user.lastPresenceStatus || "Available";
  }

  

    const lastPresenceStatus = (state: string) => {
    if (state) {
        if (state.startsWith("AVL")) {
          return "green"
        }
        if (state.startsWith("BSY") || state.startsWith("DND")) {
          return "red"
        }
        if (state.startsWith("INV")) {
          return "gray"
        }
        return "gray"
      }
      return "gray"
    }


    const Metric = (({widget} : {widget: {label: string, key: string; visible: boolean}}) => {
      const {key, label, visible} = widget;

      if (!visible) return <></>;
      
      if (key === "agent-count") {
        return (
          <div className='status-block'>
            <div className='status-block-header'>
              <People fontSize='small' /> {agents.length} 
            </div>
            <div className='status-block-subtext'>Agents</div>
          </div>
        )
      }
      if (key === 'available-agents') {
        return (
          <div className='status-block'>
            <div className='status-block-header'>
              <PersonRounded style={{color: "green"}} fontSize="small" />{available}
            </div>
            <div className='status-block-subtext'>Available</div>
          </div>
        )
      }
      if (key === 'busy-agents') {
        return (
          <div className='status-block'>
            <div className='status-block-header'>
              <PersonRounded style={{color: "red"}} fontSize="small" />{busy}
            </div>
            <div className='status-block-subtext'>Busy</div>
          </div>
        )
      }
      if (key === 'unavailable-agents') {
       return (
        <div className='status-block'>
          <div className='status-block-header'>
            <PersonOutline style={{color: "red"}} fontSize="small" />{agents.length - available - busy}
          </div>
          <div className='status-block-subtext'>Unavailable</div>
        </div>
       )
      }
      if (key === 'call-count') {
        return (
          <div className='status-block'>
            <div className='status-block-header'>
            <Phone fontSize="small"  /> {totalCalls}
            </div>
            <div className='status-block-subtext'>Calls</div>
          </div>
        )
      }
      if (key === 'waiting-count') {
        return (
          <div className='status-block' >
          <div className='status-block-header'>
            <HourglassEmpty fontSize="small" />{waiting.length}
          </div>
          <div className='status-block-subtext'>Waiting</div>
        </div> 
        )
      }
      if (key === 'answered-count') {
        return (
          <div className='status-block' >
            <div className='status-block-header'>
              <Call fontSize="small" />{answered.weight}
            </div>
            <div className='status-block-subtext'>Answered</div>
          </div> 
        )
      }
      if (key === 'voicemail-count') {
        return (
          <div className='status-block' >
          <div className='status-block-header'>
            <Voicemail fontSize="small" style={{paddingRight: 4, color: 'red'}}  />{voicemail.weight}
          </div>
          <div className='status-block-subtext'>Voicemail</div>
        </div> 
        )
      }
      if (key === 'abandoned-count') {
        return (
          <div className='status-block' >
          <div className='status-block-header'>
            <CallEnd fontSize="small" style={{paddingRight: 4}} />{abandoned.weight}
          </div>
          <div className='status-block-subtext'>Abandoned</div>
        </div> 
        )
      }
      if (key === 'other-count') {
        return ( 
          <div className='status-block' >
              <div className='status-block-header'>
                <CallMissed fontSize="small" style={{paddingRight: 4, color: 'red'}}  />{missed.weight}
              </div>
              <div className='status-block-subtext'>Other</div>
            </div> 
        )
      }
      if (key === 'other-pct') {
        return (
          <div className='status-block' >
          <div className='status-block-header'>
            {/* <Call fontSize="small" /> */}
            {answered.weight ? `${Math.floor(missed.weight / ((answered.weight + abandoned.weight + voicemail.weight + missed.weight) || 1) * 100)}%` : "--"}
          </div>
          <div className='status-block-subtext'>Other %</div>
        </div> 
        )
      }
      if (key === 'answered-pct') {
        return (
          <div className='status-block' >
            <div className='status-block-header'>
              {/* <Call fontSize="small" /> */}
              {answered.weight ? `${Math.floor(answered.weight / ((answered.weight + abandoned.weight + voicemail.weight + missed.weight) || 1) * 100)}%` : "--"}
            </div>
            <div className='status-block-subtext'>Answered %</div>
          </div> 
        )
      }
      if (key === 'abandoned-pct') {
        return (
          <div className='status-block' >
            <div className='status-block-header'>
              {/* <CallEnd fontSize="small" style={{paddingRight: 4}} /> */}
              {abandoned.weight ? `${Math.floor(abandoned.weight / ((answered.weight + abandoned.weight + voicemail.weight + missed.weight) || 1) * 100)}%` : "--"}
            </div>
            <div className='status-block-subtext'>abandoned %</div>
          </div> 
        )
      }
      if (key === 'voicemail-pct') {
        return (
          <div className='status-block' >
              <div className='status-block-header'>
                {/* <Voicemail fontSize="small" style={{paddingRight: 4, color: 'red'}} /> */}
                {voicemail.weight ? `${Math.floor(voicemail.weight / ((answered.weight + voicemail.weight + abandoned.weight + missed.weight) || 1) * 100)}%`: "--"}
              </div>
              <div className='status-block-subtext'>voicemail %</div>
            </div> 
        )
      }
      if (key === "longest-waiting") {
        return (
          <div className='status-block' >
          <div className='status-block-header'>
            {longestWait}
          </div>
          <div className='status-block-subtext'>Longest Wait</div>
        </div> 
        )
      }
      return <>n</>;
    })



    if (excluded) {
      return null;
    }


   return (
    <div className={`queue-widget-item-compact ${mode === 'light' ? "light" : "dark"}`}>
      <div className={`queue-widget-item-header ${activeCall ? "red-strip" : "green-strip"}`}>
        <div className='queue-widget-header-left'>
       <RcButton color={mode === 'light' ? "black" : "white"} style={{fontSize: '1em', fontWeight: 'bold', display: 'flex', alignItems: 'center'}} size='xl' onClick={() => setExpanded((prev) => !prev)}>
       {!expanded ? (
        <div className="queue-widget-header-button-container">
          <KeyboardArrowDown fontSize='small' />
          {activeCall ?  (
            <PhoneInTalk style={{color: 'red'}} className='compact-widget-ringing-icon' />
          ) :            
           <PhoneInTalk style={{color: '#00000000'}} className='compact-widget-ringing-icon' />
           }
        </div>) : 
        <div className="queue-widget-header-button-container">
          <KeyboardArrowUp fontSize='small' />
          {activeCall ?  (
            <PhoneInTalk style={{color: 'red'}} className='compact-widget-ringing-icon' />
          ) :            
           <PhoneInTalk style={{color: '#00000000'}} className='compact-widget-ringing-icon' />
           }
        </div>
          }
        {titleDisplay === 'ext-name' && <div className="notranslate">{extension && `(${extension}) `}{queueName}</div>}
        {titleDisplay === 'name-ext' && <div className="notranslate">{queueName}{extension && `(${extension})`}</div>}

       
       </RcButton>
        </div>
        <div className='queue-widget-header-right' style={{opacity: expanded ? 1 : 0, flexWrap: 'wrap'}}>
          {
            _compactWidgetMetrics !== undefined && _compactWidgetMetrics.map((widget) => <Metric widget={widget} />)
          }
        </div>
      </div>
     <Collapse in={expanded}>
     <div className={`queue-widget-body-container-compact ${sidebar ? "sidebar-open" : "sidebar-closed"} ${activeCall ? "red" : "green"}`}>
        {
          queueAgents && queueAgents.length && agents
          .sort((a: any, b: any) => {
            if (a?.emergency && !b?.emergency) {
              return userSortDirection === "asc" ? -1 : 1;
            }
            if (b?.emergency && !a?.emergency) {
              return userSortDirection === "asc" ? 1 : -1;
            }
            if (userSortField === "presence") {
              const aPresence = calculatePresence(a);
              const bPresence = calculatePresence(b);
      
              if (aPresence > bPresence) {
                return userSortDirection === "asc" ? 1 : -1;
              }
      
              if (aPresence < bPresence) {
                return userSortDirection === "asc" ? -1 : 1;
              }
            }
      
            if (userSortField === "department") {
              if ((a.department || "") > (b.department || "")) {
                return userSortDirection === "asc" ? 1 : -1;
              }
      
              if ((a.department || "") < (b.department || "")) {
                return userSortDirection === "asc" ? -1 : 1;
              }
            }
      
            if (userSortField === "firstName") {
              if ((a.firstName || "") > (b.firstName || "")) {
                return userSortDirection === "asc" ? 1 : -1;
              }
      
              if ((a.firstName || "") < (b.firstName || "")) {
                return userSortDirection === "asc" ? -1 : 1;
              }
            }
      
            if (userSortField === "lastName") {
              if ((a.lastName || "") > (b.lastName || "")) {
                return userSortDirection === "asc" ? 1 : -1;
              }
      
              if ((a.lastName || "") < (b.lastName || "")) {
                return userSortDirection === "asc" ? -1 : 1;
              }
            }
      
            if (userSortField === 'queuePresence') {
              const direction = userSortDirection === 'asc' ? 1 : -1;
              const statusPriority: Record<string, number> = {
                  takeAllCalls: 1,
                  doNotAcceptDepartmentCalls: 2,
                  doNotAcceptAnyCalls: 3,
                  undefined: 4,
                  "": 4,
              };
  
              const displayPriority = (display: string | undefined): number => {
                  if (display?.startsWith("AVL")) return 1;
                  if (display?.startsWith("BSY")) return 2;
                  if (display?.startsWith("DND")) return 3;
                  if (display?.startsWith("INV")) return 4;
                  if (display === "" || display === undefined) return 5;
                  return 6;
              };
  
              if (a.acceptCurrentQueueCalls !== b.acceptCurrentQueueCalls) {
                  return (a.acceptCurrentQueueCalls ? -1 : 1) * direction;
              }
  
              if (a.acceptQueueCalls !== b.acceptQueueCalls) {
                  return (a.acceptQueueCalls ? -1 : 1) * direction;
              }
  
              const statusDiff = (statusPriority[a.lastPresenceStatus] || 4) - (statusPriority[b.lastPresenceStatus] || 4);
              if (statusDiff !== 0) return statusDiff * direction;
  
              return (displayPriority(a.display) - displayPriority(b.display)) * direction;
          }
  
            if (userSortDirection === "asc") {
              return (
                parseInt(a.extensionNumber, 10) - parseInt(b.extensionNumber, 10)
              );
            }
      
            return parseInt(b.extensionNumber, 10) - parseInt(a.extensionNumber, 10);
          })
          .filter((user) => {
            if (!user.displayStatus) return null;
            if (user && user.displayStatus) {
              if (user.displayStatus.startsWith('AVL')) {
                return showAvailable ? user : null;
              }
              if (user.displayStatus.startsWith('DND')) {
                return showDnd ? user : null;
              }
              if (user.displayStatus.startsWith('BSY')) {
                return showBusy ? user : null;
              }
              if (user.displayStatus.startsWith('INV')) {
                return showInvisible ? user : null;
              }
                return showInvisible ? user : null;
           }
            return user;
          }).map((agent, i) => (
            <button type="button"  onClick={() => adminClick(agent.id)} style={{animationDuration: `0.0${i}s`, cursor: 'pointer',}} className={`queue-widget-body-item-compact ${lastPresenceStatus(agent.displayStatus)}`}>
              <div style={{textAlign: 'start'}}>
                <div className="notranslate">{agent.name}</div>
                {/* <img src={agent.portrait} alt="img" /> */}
                <div style={{fontSize: '0.75em'}}><LiveSummary agent={agent} /></div>    
              </div>          
              <div>
                {agent.availableAccepting && <PersonRounded fontSize="small" style={{color: 'green'}} />}
                {agent.busyAccepting && <PersonRounded fontSize="small" style={{color: 'red'}} />}
                {agent.notAccepting &&<PersonOutline fontSize="small" style={{color: 'red'}} />}
                {!agent.availableAccepting && !agent.busyAccepting && !agent.notAccepting && <PersonOutline fontSize="small" style={{color: 'red'}} />}
              </div>
            </button>
          ))
        }
      </div>
      </Collapse>
    </div>
  )
})

export default WidgetCompact